export default "__VITE_ASSET__D4SEQ$u5__"